import {Component, Inject, OnDestroy, OnInit} from "@angular/core";

import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {FileUploadModule} from "primeng/fileupload";
import {ToastModule} from "primeng/toast";
import {ButtonModule} from "primeng/button";
import {BadgeModule} from "primeng/badge";
import {FormControl, FormsModule, Validators} from "@angular/forms";
import {FileUploadError, getNameWithoutExtension} from "@gnv-shared/utils";
import {TranslateModule} from "@ngx-translate/core";
import {Subject} from "rxjs";
import {ExportTemplatesActions} from "../../../../store";
import {UploadDialogParam, UploadDialogResponseParam} from './models/upload-dialog.models';
import {DropdownComponent} from '@gnv-shared/components';
import { DafUploadType } from 'swagger-gen/gnvert-secured/models/daf-upload-type';

@Component({
  selector: "app-dialog-create-template",
  standalone: true,
  imports: [
    FormsModule,
    FileUploadModule,
    ToastModule,
    ButtonModule,
    BadgeModule,
    TranslateModule,
    MatDialogModule,
    DropdownComponent
],
  templateUrl: "./dialog-create-template.component.html",
  styleUrls: ["./dialog-create-template.component.scss"],
})
export class DialogCreateTemplateComponent implements OnInit, OnDestroy {
  public maxFileSize = 15000000;
  public allowedExtensions = '.xlsm';
  public dafTypeFormControl = new FormControl<DafUploadType.PDV | null>(null, {validators: Validators.required});

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DialogCreateTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadDialogParam,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.allowedExtensions = this.data?.allowedExtensions ?? this.allowedExtensions;
  }

  onUploadHandler(event: { files: File[] }) {
    if (event?.files?.length > 0) {
      try {
        const file = event.files[0];
        const name = getNameWithoutExtension(file.name);

        if (this.data?.dafSummary) {
          if (this.dafTypeFormControl.value != null) {
            const result: UploadDialogResponseParam = {
              fileName: name,
              file: file,
              dafSummary: {dafType: this.dafTypeFormControl.value!}
            }
            this.dialogRef.close(result);
          } else {
            this.dafTypeFormControl.markAsTouched();
          }
        } else {
          this.store.dispatch(ExportTemplatesActions.createModel({modelName: name, file}));
          this.dialogRef.close();
        }

      } catch (error) {
        if (error instanceof FileUploadError) {
          console.error("Upload error :", error.message);
        } else {
          console.error(error);
        }
      }
    }
  }

  ngOnDestroy() {
    this.destroy$?.next();
    this.destroy$?.complete();
  }
}
